import { createContext, useContext, useState, type Dispatch } from "react"; 
const XsollaLoadingContext = createContext({
  loading: false,
  setLoading: (() => undefined) as Dispatch<any>,
});

export function LoadingProvider({ children }: any) {
    const [loading, setLoading] = useState(false);
    return (
          <XsollaLoadingContext.Provider value={{loading, setLoading}}>{children}</XsollaLoadingContext.Provider>
        );
}

export function useLoading() {
    const context = useContext(XsollaLoadingContext);
    if (!context) {
          throw new Error("useLoading must be used within LoadingProvider");
        }
    return context;
}
